import React from "react";
import { formatDateWithTime } from "../../../shared/utilityTsx";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

type QuantityValue = number | string | null;

export interface BarcodeHistoryRow {
  id: number | string;
  action?: string | null;
  created_date?: string | null;
  operator?: string | null;
  amount?: string | number | null;
  net_weight_kg?: QuantityValue;
  net_weight_lbs?: QuantityValue;
  piece_count?: QuantityValue;
  from_warehouse_name?: string | null;
  from_warehouse_location?: string | null;
  to_warehouse_name?: string | null;
  to_warehouse_location?: string | null;
  reason?: string | null;
}

interface BarcodeHistoryTableProps {
  historyData?: BarcodeHistoryRow[] | null;
}

const hasQuantity = (value: QuantityValue | undefined): boolean =>
  value !== null && value !== undefined && value !== "";

const formatQuantity = (value: QuantityValue, unit: string): string => {
  const numericValue = Number(value);
  const formattedValue = Number.isFinite(numericValue)
    ? numericValue.toLocaleString("en-US", { maximumFractionDigits: 4 })
    : String(value);

  return `${formattedValue} ${unit}`;
};

export const formatBarcodeHistoryQuantity = (
  history: BarcodeHistoryRow,
): string => {
  const quantities = [
    hasQuantity(history.net_weight_kg)
      ? formatQuantity(history.net_weight_kg!, "kg")
      : null,
    hasQuantity(history.net_weight_lbs)
      ? formatQuantity(history.net_weight_lbs!, "lbs")
      : null,
    hasQuantity(history.piece_count)
      ? formatQuantity(history.piece_count!, "pieces")
      : null,
  ].filter((quantity): quantity is string => quantity !== null);

  return quantities.length > 0 ? quantities.join(" / ") : String(history.amount ?? "—");
};

export default function BarcodeHistoryTable({
  historyData = [],
}: BarcodeHistoryTableProps) {

  const bodyFormatCreatedDate = (item: BarcodeHistoryRow) => {
    return <p>{formatDateWithTime(item.created_date)}</p>;
  };

  return (
    <div className="flow-root">
      <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 space-y-2">
          <div className="overflow-hidden card-custom bg-white">
            <DataTable
              value={historyData ?? []}
              dataKey="id"
              tableClassName="min-w-full bg-white divide-y divide-gray-300 text-sm"
              cellClassName={() => "p-2 border-1-bottom-gray text-sm"}
              emptyMessage="No barcode history found"
            >
              <Column header="Action" field="action" style={{ width: "15%" }} />
              <Column
                header="Date"
                body={bodyFormatCreatedDate}
                style={{ width: "15%" }}
              />
              <Column
                header="Operator"
                field="operator"
                style={{ width: "10%" }}
              />
              <Column
                header="Quantity"
                body={(item: BarcodeHistoryRow) =>
                  formatBarcodeHistoryQuantity(item)
                }
                bodyClassName="text-right tabular-nums"
                headerClassName="text-right"
                style={{ width: "15%" }}
              />
              <Column
                header="From Warehouse"
                field="from_warehouse_name"
                style={{ width: "15%" }}
              />
              <Column
                header="From Location"
                field="from_warehouse_location"
                style={{ width: "15%" }}
              />
              <Column
                header="To Warehouse"
                field="to_warehouse_name"
                style={{ width: "10%" }}
              />
              <Column
                header="To Location"
                field="to_warehouse_location"
                style={{ width: "10%" }}
              />
              <Column header="Reason" field="reason" style={{ width: "15%" }} />
            </DataTable>
          </div>
        </div>
      </div>
    </div>
  );
}
